// GW 検出詳細ドロワーの本文。SF finding-detail の簡略版（Salesforce 参照なし）。
import type { Finding, FindingStatus } from "./audit-data";
import type { AssistantContext } from "./sections";
import { createSeverityBadge } from "./components/severity-badge";

export interface FindingDetailDeps {
  // 注入時のみ「AIに相談」ボタンを表示する。
  readonly openAssistant: (context: AssistantContext) => void;
}

const STATUS_LABEL: Record<FindingStatus, string> = { pass: "合格", fail: "要対応", na: "対象外", review: "要確認" };

function section(title: string, text: string): HTMLElement {
  const s = document.createElement("section");
  const h = document.createElement("h3");
  h.className = "text-sm font-medium text-slate-900";
  h.textContent = title;
  const p = document.createElement("p");
  p.className = "mt-1 text-sm text-slate-700";
  p.textContent = text;
  s.append(h, p);
  return s;
}

export function createGwFindingDetail(f: Finding, deps?: FindingDetailDeps): HTMLElement {
  const c = f.check;
  const wrap = document.createElement("div");
  wrap.className = "space-y-4 text-sm text-slate-700";

  const head = document.createElement("div");
  head.className = "flex items-center gap-2";
  head.append(createSeverityBadge(c.severity));
  const status = document.createElement("span");
  status.className = "text-slate-500";
  status.textContent = STATUS_LABEL[f.status];
  head.append(status);
  wrap.append(head);

  wrap.append(
    section("内容", c.what),
    section("リスク", c.why),
    section("対処", c.remediation),
  );

  if (f.affectedResources.length > 0) {
    const s = document.createElement("section");
    const h = document.createElement("h3");
    h.className = "text-sm font-medium text-slate-900";
    h.textContent = "影響 (" + String(f.affectedCount) + ")";
    const ul = document.createElement("ul");
    ul.className = "mt-1 list-disc pl-5";
    const SHOWN = 50;
    for (const r of f.affectedResources.slice(0, SHOWN)) {
      const li = document.createElement("li");
      li.textContent = r;
      ul.append(li);
    }
    s.append(h, ul);
    // 50 件超は黙って切り詰めず「ほか N 件」を明示する（mock honesty: 表示≠全件を隠さない）。
    if (f.affectedResources.length > SHOWN) {
      const more = document.createElement("p");
      more.className = "mt-1 text-xs text-slate-500";
      more.textContent = "ほか " + String(f.affectedResources.length - SHOWN) + " 件";
      s.append(more);
    }
    wrap.append(s);
  }

  const openAssistant = deps?.openAssistant;
  if (openAssistant) {
    const ai = document.createElement("button");
    ai.type = "button";
    ai.className = "rounded bg-shinonome-700 px-3 py-2 text-sm font-medium text-white hover:bg-shinonome-800";
    ai.textContent = "AIに相談";
    ai.addEventListener("click", () => openAssistant({ title: c.title, prompt: "「" + c.title + "」の対応策を教えて" }));
    wrap.append(ai);
  }

  return wrap;
}
